<script>
  import { v4 as uuid } from "@lukeed/uuid";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-browser
  import { browser } from "$app/environment";
  /**
   * The component you want to initialize
   * @type {new (args: { target: any; props?: any; }) => import('svelte').SvelteComponent}
   */
  export let component;
  /**
   * The name of the component. This will be used to build the island import.
   * @type {string}
   */
  export let name;

  /**
   * The props to set on the is-land element, e.g. { 'on:visible': true }
   */
  export let islandProps = {};
  const id = `island-${uuid()}`;
  const importPath = `/__islands/${name}.js`;
  // once we start client-side rendering, we don't want to initialize the island and import unnecessary code
  const renderIsland = !browser;
  const dataProps = JSON.stringify($$restProps);
</script>

<is-land {...islandProps} {id}>
  <svelte:component this={component} {...$$restProps} />
  {#if renderIsland}
    <template data-island>
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      {@html `
        <script type="module">
            import App from '${importPath}';
            let target = document.getElementById('${id}');
            if (target) {
              new App({
                target,
                props: '${dataProps}',
                hydrate: true
              });
            }
        </script>
        `}
    </template>
  {/if}
</is-land>
